import { useRecoilValue } from "recoil";

import {
  isStaleEditFormDto,
  loadersEditFormDataSF,
  loadingEditFormContentAtomFamily,
  type RydeUiUnit,
} from "@ryde/shared";

export const useEditFormDrawerLoading = ({
  entity,
  requestedId,
  dtoId,
  hasDto,
}: {
  entity: RydeUiUnit;
  requestedId?: number;
  dtoId?: number;
  hasDto?: boolean;
}): {
  isFormContentLoading: boolean;
  isFormFooterLoading: boolean;
} => {
  const isEntityContentLoading = useRecoilValue(
    loadingEditFormContentAtomFamily(entity),
  );
  const isFormBusy = useRecoilValue(loadersEditFormDataSF(entity));
  const isDtoStale = isStaleEditFormDto({
    requestedId,
    dtoId,
    hasDto,
  });

  return {
    isFormContentLoading: isEntityContentLoading || isDtoStale,
    isFormFooterLoading: isFormBusy || isDtoStale,
  };
};
